import {
  Modal,
  Tabs,
  Text,
  Image,
  Box,
  Skeleton,
  useMediaQuery,
} from '@lounge-fe/ui-kit'
import { ModalContentProps } from '@lounge-fe/ui-kit/src/components/Modal/types'
import { BenefitsData } from './types'
import { IconMap } from './IconMap'

export const BenefitsModal = ({
  onClose,
  data,
  ...props
}: Partial<ModalContentProps> & {
  onClose?: () => void
  data: BenefitsData
}) => {
  const isDesktop = useMediaQuery(({ screens }) => `(min-width: ${screens.sm})`)

  return (
    <>
      <Modal.Content {...props} className="sm:max-w-[680px]">
        <Modal.Header className="border-none text-center">
          <Modal.CloseButton
            onClick={onClose}
            className="bg-transparent hover:bg-transparent"
          />
          <Text
            variant="display-two"
            className="text-2xl font-light italic leading-xl"
          >
            {data.modal?.title}
          </Text>
        </Modal.Header>
        <Modal.Body className="px-0 py-0">
          <Tabs id="benefits-tabs">
            <Tabs.Header>
              <Tabs.Tab>{data.modal?.tabs?.retail?.title}</Tabs.Tab>
              <Tabs.Tab>{data.modal?.tabs?.hq?.title}</Tabs.Tab>
            </Tabs.Header>
            <Tabs.Panels>
              <Tabs.Panel>
                <div className="flex flex-col">
                  {isDesktop && (
                    <div className="px-8 pt-6 pb-0">
                      {data.modal?.tabs?.retail?.image?.src ? (
                        <Image
                          src={data.modal?.tabs?.retail?.image?.src}
                          alt={
                            data.modal?.tabs?.retail?.image?.alt ||
                            'Retail Benefits Image'
                          }
                          className="object-cover aspect-[1.9/1] w-full"
                          width={900}
                          height={474}
                        />
                      ) : (
                        <Skeleton>
                          <div className="aspect-[1.9/1] w-full bg-surface-secondary" />
                        </Skeleton>
                      )}
                    </div>
                  )}
                  <div className="p-8">
                    <div className="grid gap-x-10 gap-y-6 grid-cols-1 sm:grid-cols-[repeat(2,max-content)] w-full">
                      {data.benefits?.retail?.map((benefit, index) => (
                        <div key={index} className="flex items-center gap-2">
                          {IconMap[benefit.icon]}
                          <Text variant="body-md">{benefit.title}</Text>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Tabs.Panel>
              <Tabs.Panel>
                <div className="flex flex-col px-8 pt-0 pb-8">
                  {isDesktop && (
                    <div className="pt-6 pb-0">
                      {data.modal?.tabs?.hq?.image?.src ? (
                        <Image
                          src={data.modal?.tabs?.hq?.image?.src}
                          alt={
                            data.modal?.tabs?.hq?.image?.alt ||
                            'HQ Benefits Image'
                          }
                          className="object-cover aspect-[1.9/1] w-full"
                          width={900}
                          height={474}
                        />
                      ) : (
                        <Skeleton>
                          <div className="aspect-[1.9/1] w-full bg-surface-secondary" />
                        </Skeleton>
                      )}
                    </div>
                  )}
                  <div className="pt-8">
                    <div className="grid gap-x-10 gap-y-6 grid-cols-1 sm:grid-cols-[repeat(2,max-content)] w-full">
                      {data.benefits?.hq?.map((benefit, index) => (
                        <div key={index} className="flex items-center gap-2">
                          {IconMap[benefit.icon]}
                          <Text variant="body-md">{benefit.title}</Text>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Tabs.Panel>
            </Tabs.Panels>
          </Tabs>
        </Modal.Body>
      </Modal.Content>
    </>
  )
}
